/* Ezequiel Beauty — product variant picker + gallery. Vanilla, no third-party. */
(function () {
  'use strict';

  var root = document.querySelector('[data-product-root]');
  if (!root) return;

  // ---- Gallery thumbnails ----
  var mainImg = root.querySelector('[data-product-main-image]');
  root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-full');
      if (mainImg && full) {
        mainImg.src = full;
        mainImg.removeAttribute('srcset');
      }
      root.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
      });
    });
  });

  // ---- Variant picker ----
  var dataEl = root.querySelector('[data-product-variants]');
  var idInput = root.querySelector('[data-variant-id]');
  var priceEl = root.querySelector('[data-product-price]');
  var addBtn = root.querySelector('[data-add-button]');
  var addLabel = root.querySelector('[data-add-label]');
  if (!dataEl || !idInput) return;

  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

  function selectedOptions() {
    var values = [];
    root.querySelectorAll('[data-option-position]').forEach(function (group) {
      var checked = group.querySelector('[data-option-input]:checked');
      if (checked) values.push(checked.value);
    });
    return values;
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function update() {
    var chosen = selectedOptions();
    var match = variants.find(function (v) {
      return v.options.length === chosen.length && v.options.every(function (o, i) { return o === chosen[i]; });
    });
    if (!match) return;
    idInput.value = match.id;
    if (priceEl) priceEl.textContent = formatMoney(match.price);
    if (addBtn && addLabel) {
      if (match.available) {
        addBtn.removeAttribute('disabled');
        addLabel.textContent = addLabel.getAttribute('data-add') || 'Add to cart';
      } else {
        addBtn.setAttribute('disabled', '');
        addLabel.textContent = 'Sold out';
      }
    }
  }

  // remember the "add to cart" label before it can change to "Sold out"
  if (addLabel) addLabel.setAttribute('data-add', addLabel.textContent.trim());

  root.querySelectorAll('[data-option-input]').forEach(function (input) {
    input.addEventListener('change', update);
  });
})();
